const removeLocale = (path: string, localeToRemove: string) => {
  if (path.startsWith(`/${localeToRemove}`)) {
    return path.substring(`/${localeToRemove}`.length)
  }

  return path
}

export default removeLocale
